module.exports = {
  init: function () {

    const form = $('.js-contacts-form');

    if (form.length > 0) {
      const pageLang = $('#form-lang').val();

      $.validator.addMethod(
        'customEmailValidation',
        function (value, element) {
          return this.optional(element) || isValidEmail(value);
        },
        'Please enter a valid email address.'
      );

      if (pageLang === 'lt') {
        $.extend($.validator.messages, {
          required: 'Šis laukas yra privalomas.',
          remote: 'Prašau pataisyti šį lauką.',
          email: 'Prašau įvesti teisingą elektroninio pašto adresą.',
          customEmailValidation: 'Prašau įvesti teisingą elektroninio pašto adresą.',
          url: 'Prašau įvesti teisingą URL.',
          date: 'Prašau įvesti teisingą datą.',
          dateISO: 'Prašau įvesti teisingą datą (ISO).',
          number: 'Prašau įvesti teisingą skaičių.',
          digits: 'Prašau naudoti tik skaitmenis.',
          equalTo: 'Prašau įvestį tą pačią reikšmę dar kartą.',
          extension: 'Prašau įvesti reikšmę su teisingu plėtiniu.',
          maxlength: $.validator.format('Prašau įvesti ne daugiau kaip {0} simbolių.'),
          minlength: $.validator.format('Prašau įvesti bent {0} simbolius.'),
          rangelength: $.validator.format('Prašau įvesti reikšmes, kurių ilgis nuo {0} iki {1} simbolių.'),
          range: $.validator.format('Prašau įvesti reikšmę intervale nuo {0} iki {1}.'),
          max: $.validator.format('Prašau įvesti reikšmę mažesnę arba lygią {0}.'),
          min: $.validator.format('Prašau įvesti reikšmę didesnę arba lygią {0}.')
        });
      }

      function isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailPattern.test(email);
      }

      $('.js-validate-form').validate();

      form.validate({
        rules: {
          email: {
            required: true,
            customEmailValidation: true // Use custom validation method
          }
        },
        submitHandler: function (form) {
          let $form = $(form);

          $('.js-form-btn', $form).hide();
          $('.js-form-loader', $form).show();
          $('.js-form-success', $form).hide();
          $('.js-form-error', $form).hide();

          $.post($form.attr('action'), $form.serialize(), function (response) {
            if (response.error) {
              $('.js-form-error', $form).html(response.error).show();
            } else {
              $('.js-form-success', $form).show();
            }

            $('.js-form-loader', $form).hide();
            $('.js-form-btn', $form).show();
          });

          return false;
        }
      });

      $('.js-show-form').click(function () {
        let button = $(this);

        button.parent().find('.js-form').show();
        button.hide();
        return false;
      });
    }

  }
};
